import { Chip, FlexRowCenter } from "designSystem/index";
import { PinData } from "csi/model/comment";
import React from "react";
import CommentsPinIcon from "./CommentsPinIcon";

export interface CommentsRevisionChipProps {
	/** name of 3D pin */
	pinName?: string;

	/** count of revision */
	revisionCount?: number;

	/** information about 3D pin */
	threeDInfo?: string;
}

const CommentsRevisionChip = (props: CommentsRevisionChipProps) => {
	const { pinName, revisionCount, threeDInfo } = props;
	const pinData: PinData = threeDInfo ? JSON.parse(threeDInfo) : null;
	const pinColor = pinData?.color;

	return revisionCount ? (
		<FlexRowCenter height={29} mt={1}>
			{pinColor && (
				<CommentsPinIcon
					pinColor={pinColor}
					pinName={pinName}
				/>
			)}
			<Chip
				res="CommentDocRevision"
				resParams={[revisionCount]}
				sx={{
					maxWidth: 150,
					fontWeight: 800,
				}}
			/>
		</FlexRowCenter>
	) : null;
};

export default CommentsRevisionChip;